const MAX_RETRY_AFTER_SECONDS = 5;

const parseRetryAfterSeconds = (raw: string | null): number | undefined => {
	if (!raw) return undefined;
	const seconds = Number(raw);
	return Number.isFinite(seconds) && seconds >= 0 ? seconds : undefined;
};

const resolveRetryDelayMs = (retryAfterSeconds: number | undefined): number | null => {
	if (retryAfterSeconds === undefined) return 0;
	return retryAfterSeconds <= MAX_RETRY_AFTER_SECONDS ? retryAfterSeconds * 1000 : null;
};

const retryAfterPolicy = { parseRetryAfterSeconds, resolveRetryDelayMs };

export default retryAfterPolicy;
